import EmptyLineItems from './svg/empty/line-items-empty.svg'

export default EmptyLineItems
